(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-info-tabs"] && !Shopify.designMode) return;
  try {
    
  class PdpInfoTabs extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-pdp-tab-panel]'));
      const nav = this.querySelector('[data-pdp-tabs-nav]');

      this.triggers = this.panels.map((panel, index) => {
        const labelEl = panel.querySelector('.pdp-tab__label');
        const label = labelEl ? labelEl.textContent.trim() : '';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pdp-info-tabs__nav-btn';
        button.setAttribute('role', 'tab');
        button.setAttribute('data-pdp-tab-trigger', '');
        button.textContent = label;
        button.addEventListener('click', () => this.activate(index));
        nav.appendChild(button);
        return button;
      });

      if (this.triggers.length > 0) {
        this.activate(0);
      }
    }

    activate(activeIndex) {
      this.panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.open = isActive;
        const wrapper = panel.closest('.pdp-tab-wrapper');
        if (wrapper) {
          wrapper.classList.toggle('is-active-tab', isActive);
        }
      });

      this.triggers.forEach((trigger, index) => {
        const isActive = index === activeIndex;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('pdp-info-tabs')) {
    customElements.define('pdp-info-tabs', PdpInfoTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
